import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { usePageTitle } from '../../hooks/usePageTitle';
import { CheckCircle2, MapPin, ShieldCheck, Users, Wrench, Award, HelpCircle, ArrowRight } from 'lucide-react';
export function AboutUs() {
  usePageTitle('About Us | MidAtlantic Mailboxes');
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-809" data-mp="3ek2kkt2j28t3">
      <TopBar data-id="element-810" data-mp="3afmf2swtt3ee" />
      <Header data-id="element-811" data-mp="3afuw8wzzeuve" />
      <Navigation data-id="element-812" data-mp="3aigyqi80mk6r" />

      <main className="flex-grow" data-id="element-813" data-mp="232ugk8vsmupg">
        {/* Hero Section */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-814" data-mp="2345j65di5wez">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-815" data-mp="1z0fu7esx1ctf">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-816" data-mp="2jbivueeu2wqp">
              First Impressions Start at the Curb
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-817" data-mp="2ab2tx9dqnxny">
              Your Mailbox Experts Since 2003
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-818" data-mp="20krfuu0cc83c">
              Welcome to MidAtlantic Mailbox, Inc. — your superstore for
              residential & commercial mailboxes, outdoor home accessories,
              street signs, and more. If you have a mailbox question, we're your
              answer.
            </p>
          </div>
        </section>

        {/* Trust & Values */}
        <section className="py-12 bg-brand-background border-b border-brand-border" data-id="element-819" data-mp="1hp19kuldkpjn">
          <div className="max-w-7xl mx-auto px-4" data-id="element-820" data-mp="1mkyocwgzpnub">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-821" data-mp="3ob7bly8h6yc2">
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-822" data-mp="3jkh52hobcpfs">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-823" data-mp="3em5to2ide6vg">
                  <ShieldCheck size={24} data-id="element-824" data-mp="3ahg1anmx7afa" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-825" data-mp="b3cn49o0eias">
                  22 Years of Service
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-826" data-mp="6640nwvtvs3q">
                  Trusted service and expert industry knowledge since our
                  founding.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-827" data-mp="3t9r0o7id8q8n">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-828" data-mp="2huvd1w1qrefy">
                  <Users size={24} data-id="element-829" data-mp="xdvvbwm7yk27" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-830" data-mp="12bxd8e7wsdc3">
                  Family Owned & Operated
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-831" data-mp="16d95kri63cnz">
                  A small generational business dedicated to our community.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-832" data-mp="1g3au1kefmx3f">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-833" data-mp="1l1m2bqp2wzjj">
                  <Award size={24} data-id="element-834" data-mp="1q29tccdb5gdr" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-835" data-mp="1u3d9z136jgg1">
                  Top-Rated Manufacturers
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-836" data-mp="3rufv9aofmzer">
                  We partner with the best to bring you quality street-scape
                  solutions.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border flex flex-col items-center text-center shadow-sm" data-id="element-837" data-mp="30ip6dr9e17y7">
                <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-838" data-mp="3aig19u1v1oyt">
                  <Wrench size={24} data-id="element-839" data-mp="35j3ef9azohw8" />
                </div>
                <h3 className="font-bold text-brand-charcoal mb-2" data-id="element-840" data-mp="35hjyxkx5qavi">
                  Professional Setup
                </h3>
                <p className="text-sm text-brand-muted" data-id="element-841" data-mp="2cv7lmfojja4q">
                  Expert project management and installation services.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Story */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-842" data-mp="2mranrlje78ro">
          <div className="max-w-7xl mx-auto px-4" data-id="element-843" data-mp="1z29bfn7fvdh4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-844" data-mp="1u47r6yya1842">
              <div data-id="element-845" data-mp="1u23o2j87cd4u">
                <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs mb-4 block flex items-center gap-2" data-id="element-846" data-mp="9m5ikrlfmbae">
                  <span className="w-6 h-px bg-brand-maroon" data-id="element-847" data-mp="edxe7gjg377e"></span>
                  Our Story
                </span>
                <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-848" data-mp="n21tu9qm7z2">
                  From a Garage Startup to a National Retailer
                </h2>
                <div className="space-y-4 text-brand-muted leading-relaxed" data-id="element-849" data-mp="sdq3d7fbpfd9">
                  <p data-id="element-850" data-mp="xc9nd2acwh2z">
                    As a small generational business, we're excited to offer
                    quality mailboxes and street-scape solutions. Our matriarch,
                    Anne Ingram, launched this woman-owned & operated company in
                    2003.
                  </p>
                  <p data-id="element-851" data-mp="341y0jxmz0rf5">
                    Over the next 22 years, she earned the reputation in the
                    Mid-Atlantic Region as the "Mailbox Lady," and now, she's
                    looking to pass the torch to her daughters.
                  </p>
                  <p data-id="element-852" data-mp="1emwvh12zpbk4">
                    In typical start-up fashion, her now-booming business all
                    began in her garage with a determination to make her mark on
                    the mailbox industry and help the community navigate a
                    confusing sector. Since that garage start-up, MidAtlantic
                    Mailbox has grown to be a top national retailer for
                    commercial and residential street-scape needs.
                  </p>
                </div>
                <div className="mt-8 flex gap-4" data-id="element-853" data-mp="lw4yw2i0ikw9">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/woman%20owned%20badge.png" alt="Woman Owned Business" className="h-16 object-contain" data-id="element-854" data-mp="lwwu3c7p6gm0" />
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/family%20owned%20badge.png" alt="Family Owned Business" className="h-16 object-contain" data-id="element-855" data-mp="2ca5kv76434re" />
                </div>
              </div>
              <div className="relative" data-id="element-856" data-mp="7szbvya38ih9">
                <div className="aspect-square lg:aspect-auto lg:h-[500px] rounded-2xl overflow-hidden shadow-lg border border-brand-border" data-id="element-857" data-mp="bszn7a1w4dk3">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/working%20hands.png" alt="MidAtlantic Mailbox Team" className="w-full h-full object-cover" data-id="element-858" data-mp="3b963v7j54ra7" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Expertise & Services */}
        <section className="py-16 lg:py-24 bg-brand-goldWash border-b border-brand-border" data-id="element-859" data-mp="zk52no3x53tv">
          <div className="max-w-7xl mx-auto px-4" data-id="element-860" data-mp="14farauopgwln">
            <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-861" data-mp="g3s8kwf5sca6">
              <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-862" data-mp="b5gxyjh1hxqw">
                Your Mailbox Experts Are Here to Help
              </h2>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-863" data-mp="oy6jynwkj2o0">
                MidAtlantic's women-led team is reaching for new heights,
                excited to serve communities, property managers, homeowners, and
                postal workers. We look forward to working directly with you and
                your land or planning departments to assist in designing your
                next project.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-864" data-mp="13twb10gm25zl">
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-865" data-mp="39n4e4l57qb57">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4" data-id="element-866" data-mp="39oxlk2nngze9">
                  Commercial Planning
                </h3>
                <ul className="space-y-3 text-brand-muted" data-id="element-867" data-mp="2vhc5xehh5upi">
                  <li className="flex items-start gap-2" data-id="element-868" data-mp="2vjydhe4d8a7q">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-869" data-mp="2zhw3uk9vh2cp" />
                    <span data-id="element-870" data-mp="2qqm1q4ksbxwe">Replacement CBU's & New Developments</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-871" data-mp="2btl79tb7lou8">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-872" data-mp="2bs1rs4xdnhti" />
                    <span data-id="element-873" data-mp="22t6niydw8hsu">Advisal of Commercial Postal Codes & Ordinances</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-874" data-mp="27rhtuz4zca6b">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-875" data-mp="27u4270zp2tpl" />
                    <span data-id="element-876" data-mp="60wlbn4fo41l">Value Engineered Development Mailbox Mapping</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-877" data-mp="172wtzroag09y">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4" data-id="element-878" data-mp="1bw9afeitd0rm">
                  Professional Installation
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-879" data-mp="124vcvcafab14">
                  We’re here to shoulder the hard parts of mailbox replacements.
                  Once installation is scheduled, there’s nothing left for you
                  to do.
                </p>
                <ul className="space-y-3 text-brand-muted" data-id="element-880" data-mp="1ut0ye19aw420">
                  <li className="flex items-start gap-2" data-id="element-881" data-mp="1guuddlpg9yjr">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-882" data-mp="1gwdufeixkdml" />
                    <span data-id="element-883" data-mp="5e2ycj350r1g">Removal, installation, and disposal</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-884" data-mp="af0bgh9aiuw3">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-885" data-mp="1wydxba4x0sp" />
                    <span data-id="element-886" data-mp="3u07o1mh7ez27">Proper positioning for easy mail delivery</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-887" data-mp="6w1lb2dl7j3u">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4" data-id="element-888" data-mp="6u8dvkv5guus">
                  Diagnostic Solutions
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-889" data-mp="3adjgoac6axnd">
                  We stay informed of postal requirements along with emerging
                  industry trends to bring you the most up to date products and
                  services.
                </p>
                <ul className="space-y-3 text-brand-muted" data-id="element-890" data-mp="3k94o4o00gq4i">
                  <li className="flex items-start gap-2" data-id="element-891" data-mp="2wk27njh453bl">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-892" data-mp="2rmjv7j3w05yu" />
                    <span data-id="element-893" data-mp="vivokuiihfeh">Model identification</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-894" data-mp="10h70rbwa41zv">
                    <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-895" data-mp="158xfrv65vdxm" />
                    <span data-id="element-896" data-mp="19a0tab0qkxvo">Affordable street themes</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-897" data-mp="hk5sni7fhlrp">
          <div className="max-w-4xl mx-auto px-4" data-id="element-898" data-mp="ljwow1fq4u3m">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-899" data-mp="lnaste41dbd6">
              Common Installation Questions
            </h2>
            <div className="space-y-6" data-id="element-900" data-mp="1wzbjwzodhbw3">
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-901" data-mp="1x2h90ex04drt">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-902" data-mp="2210y2o6w65oe">
                  <HelpCircle size={20} className="text-brand-maroon" data-id="element-903" data-mp="2c4z8bubtjw7m" />
                  Why should MidAtlantic Mailbox install my mailbox?
                </h3>
                <p className="text-brand-muted leading-relaxed" data-id="element-904" data-mp="22c0he5suntku">
                  <strong data-id="element-905" data-mp="1yc9l5mkk0l8x">Ease of Mind:</strong> We’ll take care of removal,
                  installation, and disposing of the old system. You don’t even
                  have to be home!
                  <br data-id="element-906" data-mp="1odtsvg9sj5xu" />
                  <strong data-id="element-907" data-mp="1odaiqlqdtlud">Professional Setup:</strong> Our experienced team
                  ensures your mailbox is installed to meet all local
                  regulations.
                  <br data-id="element-908" data-mp="1fd5eulked5ky" />
                  <strong data-id="element-909" data-mp="1fdxafwdzv3b8">Durability and Security:</strong> Our manufacturers
                  use high-quality materials to ensure your mailbox lasts for
                  years.
                </p>
              </div>

              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-910" data-mp="39rep0twf8pu4">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-911" data-mp="3gvehotlr0dpd">
                  <HelpCircle size={20} className="text-brand-maroon" data-id="element-912" data-mp="3lrv2pexniby8" />I didn't
                  buy my mailbox from MidAtlantic Mailbox. Will you still
                  install it?
                </h3>
                <p className="text-brand-muted leading-relaxed" data-id="element-913" data-mp="3btfcde6g76ps">
                  It depends! If you are in our service area and there is
                  availability on our schedule, we can complete a direct burial
                  installation. However, we can only guarantee the craftsmanship
                  of the physical installation; any issues with the products
                  should be brought to the company you purchased from.
                </p>
              </div>

              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-914" data-mp="2f62dpq0nuzsl">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-915" data-mp="2k2suygo7c1fl">
                  <HelpCircle size={20} className="text-brand-maroon" data-id="element-916" data-mp="20itwa7grdy86" />
                  Do I need Post Office approval to replace my mailbox?
                </h3>
                <p className="text-brand-muted leading-relaxed mb-4" data-id="element-917" data-mp="29ih1738p5m5z">
                  Unless you’re moving your mailbox location, you generally
                  don’t need USPS approval to complete a residential
                  installation. We’ll ensure your mailbox is compliant with USPS
                  regulations during installation. All of MidAtlantic Mailbox’s
                  products are also USPS Approved.
                </p>
                <a href="/USPSResources.html" className="inline-flex items-center text-brand-maroon font-semibold hover:text-brand-maroonDark transition-colors" data-id="element-918" data-mp="2t66k0kynoc32">
                  View USPS resources <ArrowRight size={16} className="ml-1" data-id="element-919" data-mp="2x8baxbxpyum0" />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Awards */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-920" data-mp="1uwq6i8g15gjo">
          <div className="max-w-7xl mx-auto px-4" data-id="element-921" data-mp="1zurm2je8yxqe">
            <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-922" data-mp="23vtqden0tzz8">
              Awards & Recognition
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-923" data-mp="28nuyqph2j6jz">
              <a href="https://www.florencemailboxes.com/dealers/midatlantic-mailbox-inc/" target="_blank" rel="noopener noreferrer" className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center hover:border-brand-maroon transition-colors group" data-id="element-924" data-mp="2dkbo1n007qyn">
                <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/florence%20logo%20badge.png" alt="Florence Manufacturing" className="h-12 object-contain mb-4" data-id="element-925" data-mp="t6bdl2h6ka9m" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1 group-hover:text-brand-maroon transition-colors" data-id="element-926" data-mp="kwdp790j9fpu">
                  Dealer of Excellence Award
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-927" data-mp="bwh57kp39514">
                  2011 to 2024 · Florence Manufacturing
                </p>
              </a>
              <div className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center" data-id="element-928" data-mp="18lya3xg8yn1r">
                <Award size={32} className="text-brand-gold mb-4" data-id="element-929" data-mp="zljkwn05wnsz" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1" data-id="element-930" data-mp="znwdrv7gkikt">
                  Best of Frederick Economic Development
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-931" data-mp="3kcalbyficehn">
                  2017 - Rooted in Frederick 15 years
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center" data-id="element-932" data-mp="3ff0m5r2bgogm">
                <Award size={32} className="text-brand-gold mb-4" data-id="element-933" data-mp="1nbmv96ujc2ob" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1" data-id="element-934" data-mp="19blml5813qya">
                  Best of Frederick Economic Development
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-935" data-mp="1eb89k6dnslka">
                  2012 - Small Business
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-brand-border text-center shadow-sm flex flex-col items-center justify-center" data-id="element-936" data-mp="222n77luhqep7">
                <Award size={32} className="text-brand-gold mb-4" data-id="element-937" data-mp="1s9g4k8r4xcst" />
                <h4 className="font-bold text-brand-charcoal text-sm mb-1" data-id="element-938" data-mp="1x9ati6rcnsb8">
                  Top 25 Seller with A+ Service
                </h4>
                <p className="text-xs text-brand-muted" data-id="element-939" data-mp="2kxka8u9phpvi">2012 Amazon</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 lg:py-24 bg-white text-center" data-id="element-940" data-mp="eacufee7ggho">
          <div className="max-w-3xl mx-auto px-4" data-id="element-941" data-mp="e8jndxzoju95">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-942" data-mp="9aqjxcprheck">
              Ready to start your project?
            </h2>
            <p className="text-lg text-brand-muted mb-8" data-id="element-943" data-mp="n5aud5frstii">
              Contact our office for a custom quote, design assistance, or any
              general questions you may have.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-944" data-mp="3rjiqldv8mofc">
              <a href="/ContactUs.html" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto" data-id="element-945" data-mp="3mkeg8jwkuknf">
                Contact Us
              </a>
              <a href="tel:301-620-7585" className="bg-white border border-brand-border hover:border-brand-maroon text-brand-charcoal px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto flex items-center justify-center gap-2" data-id="element-946" data-mp="1fqkhy62svxuy">
                Call 301-620-7585
              </a>
            </div>
            <div className="mt-10 pt-8 border-t border-brand-border text-sm text-brand-muted max-w-xl mx-auto" data-id="element-947" data-mp="1ai437eq29fh7">
              <p className="font-semibold text-brand-charcoal mb-1" data-id="element-948" data-mp="15hga8ni9uokc">
                MidAtlantic Mailbox, Inc.
              </p>
              <p className="flex items-center justify-center gap-2 mb-3" data-id="element-949" data-mp="1jgg0fzlfnbim">
                <MapPin size={16} className="text-brand-gold shrink-0" data-id="element-950" data-mp="1ei4mpds0ogv4" />
                4507 Metropolitan Court Ste. D, Frederick, MD 21704
              </p>
              <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1" data-id="element-951" data-mp="1o8zawnotpqj7">
                <span data-id="element-952" data-mp="1obbv77i20czf">Toll Free: 1-800-806-7997</span>
                <span className="hidden sm:inline text-brand-border" data-id="element-953" data-mp="229jw1qi7nyfv">|</span>
                <span data-id="element-954" data-mp="1y7ybdizfqfv4">Local: 301-620-7585</span>
                <span className="hidden sm:inline text-brand-border" data-id="element-955" data-mp="1y52dfunl7r6o">|</span>
                <span data-id="element-956" data-mp="2gwqw3165rbzz">301-620-7867</span>
                <span className="hidden sm:inline text-brand-border" data-id="element-957" data-mp="2luk3tyn40e2d">|</span>
                <span data-id="element-958" data-mp="2ltr2jd6x6grm">240-575-5852</span>
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-959" data-mp="27x3yyrkgoscq" />
      <MobileStickyBar data-id="element-960" data-mp="2ctly9bx0vyho" />
    </div>;
}